import * as constants from './constants';
import * as messages from './messages';
import {all, create} from 'admin-ng/api/documents';
import {fetchDocuments} from '../documents-index/actions';

export const updateName = name => ({
  type: constants.UPDATE_NAME,
  name,
});

export const updateExternalName = externalName => ({
  type: constants.UPDATE_EXTERNAL_NAME,
  externalName,
});

export const updateText = text => ({
  type: constants.UPDATE_TEXT,
  text,
});

export const toggleCheckbox = boxname => ({
  type: constants.TOGGLE_CHECKBOX,
  boxname,
});

export const requestNameCheck = (params = {}) => ({
  type: constants.REQUEST_NAME_CHECK,
  params,
});

export const requestNameCheckSuccess = isNameUnique => ({
  type: constants.REQUEST_NAME_CHECK_SUCCESS,
  isNameUnique,
});

export const requestNameCheckFail = (error = messages.DEFAULT_ERROR_MSG) => ({
  type: constants.REQUEST_NAME_CHECK_FAIL,
  error,
});

export function checkName(name) {
  return function (dispatch) {
    const params = {
      name__ieq: name,
    };

    dispatch(requestNameCheck(params));

    return all(params)
      .then((res = {}) => {
        if (res.body && res.body.results) {
          if (res.body.results.length >= 1) {
            dispatch(requestNameCheckSuccess(false));
          } else {
            dispatch(requestNameCheckSuccess(true));
          }
        } else {
          dispatch(requestNameCheckFail());
        }
      })
      .catch((err = {}) => {
        dispatch(requestNameCheckFail(err.message));
      });
  };
}

export const requestCreate = (params = {}) => ({
  type: constants.REQUEST_CREATE,
  params,
});

export const requestCreateSuccess = () => ({
  type: constants.REQUEST_CREATE_SUCCESS,
});

export const requestCreateFail = (error = messages.DEFAULT_ERROR_MSG) => ({
  type: constants.REQUEST_CREATE_FAIL,
  error,
});

export function createNewDocument() {
  return function (dispatch, getState) {
    const state = getState().documents.create;
    const params = {
      deprecated: state.deprecated,
      external_name: state.externalName,
      name: state.name,
      required_for_signup: state.requiredForSignup,
      separate: state.separate,
      text: state.text,
    };

    dispatch(requestCreate(params));

    return create(params)
      .then(() => {
        dispatch(requestCreateSuccess());
        dispatch(fetchDocuments());
      })
      .catch((err = {}) => {
        dispatch(requestCreateFail(err.message));
      });
  };
}

export const resetState = () => ({
  type: constants.RESET_STATE,
});
